export function createModule (platform, { capturedGet, capturedPost, capturedPut, capturedRemove } = {}) {
  const state = {}
  const getters = {}
  const mutations = {}
  const actions = {
    async getAdUsers (context) {
      return capturedGet(`/${platform}/ads/ad/adselect`)
    },
    async getPromotions (context, { params }) {
      return capturedGet(`/${platform}/apps-promotion`, params)
    },
    async addAndUpdatePromotion (context, { type, id, params }) {
      const requestMethod = type === 'edit' ? capturedPut : capturedPost
      return requestMethod(`/${platform}/apps-promotion${ type === 'edit' ? '/' + id : '' }`, params)
    },
    async removePromotion (context, { id }) {
      return capturedRemove(`/${platform}/apps-promotion/${id}`)
    },
    async getPromotionDetail (context, { id }) {
      return capturedGet(`/${platform}/apps-promotion/${id}`)
    },
    async batchStartAndStopPromotion (context, { isStart, ids }) {
      return capturedPost(`/${platform}/apps-promotion/${ isStart ? 'batchstart' : 'batchstop' }`, { ids })
    },
    async getSelectData (context, { params }) {
      return capturedGet(`/${platform}/apps-promotion/selectlist`, params)
    },
    async validatePromotionName (context, { value }) {
      return capturedGet(`/${platform}/apps-promotion/is-repeated`, { name: value })
    },
    async getPromotionBidding (context, { appName }) {
      return capturedGet(`${platform}/apps-promotion/bidding`, { app_name: appName })
    }
  }

  return {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
}
